<button
    mat-menu-trigger
    type="button"
    class="htaswipper-trigger"
    [matMenuTriggerFor]="switcherMenu"
    [disabled]="loading()">
    @if (loading()) {
        <mat-spinner diameter="16"></mat-spinner>
    } @else {
        <mat-icon class="htasw-chip-icon" [svgIcon]="'heroicons_outline:building-office'"></mat-icon>
    }
    <span class="htasw-chip-label" [class.placeholder]="!currentLabel()">
        {{ currentLabel() || 'Corporativo' }}
    </span>
    <mat-icon class="htasw-chevron">keyboard_arrow_down</mat-icon>
</button>

<mat-menu #switcherMenu="matMenu" [yPosition]="'below'" class="htasw-menu">
    <div class="htasw-menu-header">
        <span class="htasw-menu-title">Cambiar de corporativo</span>
    </div>

    @if (tenants().length === 0) {
        <button mat-menu-item type="button" disabled class="!cursor-default">
            <span class="text-gray-400">No hay corporativos disponibles</span>
        </button>
    }

    @for (t of tenants(); track t.tenantId) {
        <button
            mat-menu-item
            type="button"
            class="!h-auto !min-h-[44px]"
            [disabled]="switching() || isCurrent(t.tenantId)"
            (click)="switchTo(t.tenantId)">
            @if (t.logoUrl) {
                <img class="mr-3 h-6 w-6 rounded" [src]="t.logoUrl" [alt]="t.name" />
            } @else {
                <mat-icon class="mr-3 text-gray-500" [svgIcon]="'heroicons_outline:building-office'"></mat-icon>
            }
            <span class="flex-1 truncate">{{ t.name }}</span>
            @if (isCurrent(t.tenantId)) {
                <mat-icon class="ml-2 text-primary" [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
            }
            @if (!isCurrent(t.tenantId) && switching()) {
                <mat-spinner diameter="16" class="ml-2"></mat-spinner>
            }
        </button>
    }
</mat-menu>
